import React from 'react';
import { SideBar } from './sidebar';
import { getAllGroups } from '../../models/groups'; //getAllEndedGroups,
import DataTable from 'react-data-table-component';
import i18n from '../../i18n';
import swal from 'sweetalert';
import { Modal, Spinner } from 'react-bootstrap';
import { HomeBanner } from '../home/homeBanner';
import { deleteMeeting, getAllMeetings, getMeeting, getMeetingAttendees, statuses } from '../../models/meetings';
import AttendeesEdit from './helper/attendeesEdit';
import { MzadLoader } from '../helpers/mzadLoader';
import AddMeeting from './meeting/meetingAdd';
import EditMeeting from './meeting/meetingEdit';
import AttendeesLists from './helper/attendees';
import { apiUrl } from '../../constants/global';
import { getLoggedUser } from '../../state/user';

const user = getLoggedUser();
let lang = localStorage.getItem('I18N_LANGUAGE');
const customStyles = {
  headCells: {
    style: {
      fontWeight: 'bold',
      backgroundColor: '#dadada',
      color: '#000000',
    },
  },
};

export class MeetingsList extends React.Component {
  constructor() {
    super();
    this.state = {
      groups: [],
      customDate: false,
      meetingGroups: [],
      ended_groups: [],
      attendees: [],
      add_popup: false,
      edit_popup: false,
      add: {},
      meetingID: null,
      signature: null,
      data: {},
      errors: {},
      is_loading: false,
      users: {},
      hideSidebar: false,
      totalRows: 0,
      currentPage: 1,
      input: {
        page: 1,
        limit: 15,
      },
      screen_val: '1',
      edit_screen_val: '1',
      columns: [
        {
          name: 'ID',
          sortable: true,
          wrap: true,
          width: '50px',
          cell: (row) => row.id,
        },
        {
          name: `${i18n.t('total_groups')}`,
          width: '130px',
          cell: (row) => (
            <button
              className="btn btn-outline-dark"
              onClick={(e) => {
                this.viewGroups(row.groups);
              }}
            >
              {row.groups.length}
            </button>
          ),
          sortable: true,
        },
        {
          name: i18n.t('title'),
          cell: (row) => {
            return `${row.title_ar} \r\n${row.title}`;
          },
          sortable: true,
          wrap: true,
        },
        {
          name: `${i18n.t('meeting')} ${i18n.t('number')}`,
          cell: (row) => {
            return `${row.number_ar} \r\n${row.number}`;
          },
        },
        {
          name: `${i18n.t('location')}`,
          cell: (row) => {
            return `${row.location_ar} \r\n${row.location}`;
          },
        },
        {
          name: `${i18n.t('final_approved_officer')}`,
          cell: (row) => {
            return row?.final_approved_officer ? `${row?.final_officer?.name_ar} \r\n${row?.final_officer?.name}` : '';
          },
        },
        {
          name: i18n.t('date'),
          width: '150px',
          cell: (row) => {
            return `${row.date}\r\n${i18n.t('start')}:${row.start_time}\r\n${i18n.t('end')}:${row.end_time}`;
          },
          sortable: true,
        },
        {
          name: i18n.t('status'),
          cell: (row) => statuses[row.status],
          sortable: true,
        },
        {
          name: i18n.t('attendees'),
          button: true,
          cell: (row) => (
            <button
              className="btn btn-outline-dark"
              onClick={(e) => {
                this.viewAttendees(row.id);
              }}
            >
              {i18n.t('attendees')}
            </button>
          ),
        },
        {
          name: i18n.t('view'),
          button: true,
          cell: (row) => (
            <button
              className={`btn btn-${row.status === 'N' ? 'warning' : 'outline-warning'}`}
              onClick={(e) => {
                this.viewRow(row.id);
              }}
            >
              {row.status === 'N' ? i18n.t('edit') : i18n.t('view')}
            </button>
          ),
        },
        {
          name: i18n.t('download'),
          button: true,
          width: '150px',
          cell: (row) =>
            row.status === 'C' && (
              <div className="d-flex justify-content-center align-items-center">
                {/* <a
                  target="_new"
                  className={`btn btn-danger rounded-0 btn-sm`}
                  href={`${apiUrl}meeting/export/pdf?mid=${row.id}&auth=${user.token}&lang=en`}
                >
                  <i className="fa fa-file-pdf-o" />
                  &nbsp;{i18n.t('english')}
                </a> */}
                <a
                  target="_new"
                  className={`btn btn-danger rounded-0 btn-sm`}
                  href={`${apiUrl}meeting/export/pdf?mid=${row.id}&auth=${user.token}&lang=ar`}
                >
                  <i className="fa fa-file-pdf-o" />
                  &nbsp;{i18n.t('report')}
                </a>
              </div>
            ),
        },
        {
          name: i18n.t('delete'),
          button: true,
          cell: (row) => (
            <button
              className="btn btn-danger"
              onClick={(e) => {
                this.deleteRow(row.id);
              }}
            >
              {i18n.t('delete')}
            </button>
          ),
        },
      ],
    };
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.handleAddChange = this.handleAddChange.bind(this);
    this.triggerReload = this.triggerReload.bind(this);
    this.loadAllGroups = this.loadAllGroups.bind(this);
    // this.loadEndedGroups = this.loadEndedGroups.bind(this);
  }

  componentDidMount() {
    // this.loadEndedGroups();
    this.loadAllGroups();
    let input = this.state.input;
    let qstring = new URLSearchParams(input).toString();
    this.loadAllMeetings(qstring);
  }

  // async loadEndedGroups() {
  //   this.setState({ groups_loading: true });
  //   const response = await getAllGroups('');
  //   //const response = await getAllEndedGroups();
  //   if (response.success) {
  //     let ended_groups = response.data;
  //     this.setState({ ended_groups });
  //     this.setState({ groups_loading: false });
  //   }
  // }

  async loadAllGroups() {
    this.setState({ groups_loading_2: true });
    const response = await getAllGroups();
    if (response.success) {
      let groups = response.data;
      this.setState({ groups });
      this.setState({ groups_loading_2: false });
    }
  }

  onFileChange = (event) => {
    if (event.target.name === 'signature') {
      this.setState({ signature: event.target.files[0] });
    }
  };

  handleChange(field, value) {
    let input = this.state.input;
    // Handle date filter logic
    if (field === 'dateFilter') {
      if (value === 'last7days') {
        const toDate = new Date();
        const fromDate = new Date();
        fromDate.setDate(toDate.getDate() - 7);

        input['fromDate'] = fromDate.toISOString().split('T')[0];
        input['toDate'] = toDate.toISOString().split('T')[0];

        this.setState({ customDate: false });
      } else if (value === 'last30days') {
        const toDate = new Date();
        const fromDate = new Date();
        fromDate.setDate(toDate.getDate() - 30);

        input['fromDate'] = fromDate.toISOString().split('T')[0];
        input['toDate'] = toDate.toISOString().split('T')[0];
        this.setState({ customDate: false });
      } else if (value === 'custom') {
        this.setState({ customDate: true });
        input['fromDate'] = '';
        input['toDate'] = '';
      }
    }

    input[field] = value;
    this.setState({ input });
  }
  handleAddChange(event) {
    let { add } = this.state;
    add[event.target.name] = event.target.value;
    this.setState({ add });
  }

  handleSearch(event) {
    let input = this.state.input;
    let qstring = new URLSearchParams(input).toString();
    this.loadAllMeetings(qstring);
  }

  async loadAllMeetings(q) {
    this.setState({ is_loading: true });
    const response = await getAllMeetings(q);
    let users = response.data;
    let meta = response.meta;
    if (response.success) {
      this.setState({ is_loading: false });
      this.setState({ users: users });
      this.setState({ totalRows: meta.total });
    } else {
      this.setState({ is_loading: false });
    }
  }

  async viewRow(id) {
    const response = await getMeeting(id);
    let data = response.data;
    this.setState({
      data,
      edit_popup: true,
      meetingID: id,
      meeting: data,
      edit_screen_val: '1',
    });
  }

  async viewAttendees(id) {
    this.setState({ attendees_loading: true });
    const response = await getMeetingAttendees(id);

    if (response.success) {
      let data = response.data;
      this.setState({ attendees_popup: true, attendees: data });
      this.setState({ attendees_loading: false });
    }
  }
  viewGroups(groups) {
    this.setState({ group_popup: true, meetingGroups: groups });
  }

  handlePageChange = (page) => {
    let input = this.state.input;
    let currentPage = page;
    input['page'] = currentPage;
    this.setState({ currentPage: currentPage });
    this.setState({ input: input });
    let qstring = new URLSearchParams(input).toString();
    this.setState({ query: qstring });
    this.loadAllMeetings(qstring);
  };

  async deleteRow(id) {
    var ans = window.confirm('Do you want to continue.?');
    if (ans) {
      const response = await deleteMeeting({ id });
      if (response.success) {
        swal(i18n.t('success'), 'Meeting deleted', 'success', {
          buttons: false,
          timer: 2000,
        })
          .then((response) => {
            let { input } = this.state;
            let qstring = new URLSearchParams(input).toString();
            this.setState({ query: qstring });
            this.loadAllMeetings(qstring);
          })
          .catch((response) => {
            swal('Failed', 'Something went wrong', 'error');
          });
      }
    }
  }

  triggerReload() {
    let { input } = this.state;
    let qstring = new URLSearchParams(input).toString();
    this.loadAllMeetings(qstring);
  }

  render() {
    let { users, groups, meetingID, meeting, attendees, attendees_loading, screen_val, edit_screen_val } = this.state;
    return (
      <React.Fragment>
        <HomeBanner />

        <section className="sptb mt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">{!this.state.hideSidebar && <SideBar />}</div>
              <div
                className={this.state.hideSidebar ? 'col-xl-12 col-lg-12 col-md-12' : 'col-xl-9 col-lg-12 col-md-12'}
              >
                <div className="card mb-0">
                  <div className="card-header d-flex justify-content-between">
                    <div className=" d-flex">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                      <h3 className="card-title">{i18n.t('meetings')}</h3>
                    </div>
                    <button
                      className="btn btn-dark"
                      onClick={(event) => {
                        this.setState({
                          add_popup: !this.state.add_popup,
                          screen_val: '1',
                        });
                      }}
                    >
                      {i18n.t('add')} {i18n.t('meeting')}
                    </button>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive ">
                      {this.state.is_loading && (
                        <div className="text-center">
                          <Spinner animation="border" size="lg" />
                        </div>
                      )}

                      <div className="row">
                        {/* <div className="col-md-3">
                          <div className="form-group">
                            <input
                              type="date"
                              name="date"
                              value={this.state.input.date}
                              onChange={(e) => this.handleChange('date', e.target.value)}
                              className="form-control custom-input "
                            />
                          </div>
                        </div> */}
                        {/* Date Filter */}
                        <div className="col-md-3">
                          <div className="form-group">
                            {/* <label className="form-label">{i18n.t('date_range')}</label> */}
                            <select
                              className="form-select"
                              onChange={(e) => this.handleChange('dateFilter', e.target.value)}
                              value={this.state.input.datefilter}
                            >
                              <option value="">{i18n.t('select_date_filter')}</option>
                              <option value="last7days">{i18n.t('last_week')}</option>
                              <option value="last30days">{i18n.t('last_month')}</option>
                              <option value="custom">{i18n.t('custom')}</option>
                            </select>

                            {/* Custom Date Range */}
                            {this.state.customDate && (
                              <div className="row g-2 mt-2">
                                <div className="col-6">
                                  {/* <label className="form-label">{i18n.t('from')}</label> */}
                                  <input
                                    type="date"
                                    className="form-control"
                                    value={this.state.input.fromDate}
                                    onChange={(e) => this.handleChange('fromDate', e.target.value)}
                                  />
                                </div>
                                <div className="col-6">
                                  {/* <label className="form-label">{i18n.t('to')}</label> */}
                                  <input
                                    type="date"
                                    className="form-control"
                                    value={this.state.input.toDate}
                                    onChange={(e) => this.handleChange('toDate', e.target.value)}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        {/* <div className="col-md-2">
                          <div className="form-group">
                            <input
                              type="text"
                              name="number"
                              value={this.state.input.number}
                              onChange={(e) => this.handleChange('number', e.target.value)}
                              className="form-control custom-input "
                              placeholder={i18n.t('number')}
                            />
                          </div>
                        </div> */}
                        {/* <div className="col-md-3">
                          <div className="form-group">
                            <select
                              className="form-control"
                              name="group"
                              value={this.state.input.group}
                              onChange={this.handleChange}
                            >
                              <option value="">-- {i18n.t('group')} --</option>
                              {groups.length > 0 &&
                                groups.map((item) => {
                                  return (
                                    <option value={item.id} key={item.id}>
                                      {lang === 'ar' ? item.group_name_ar : item.group_name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>
                        </div> */}
                        <div className="col-md-3">
                          <div className="form-group">
                            <select
                              className="form-control"
                              name="meeting_status"
                              value={this.state.input.meeting_status}
                              onChange={(e) => this.handleChange('meeting_status', e.target.value)}
                            >
                              <option value="">-- {i18n.t('status')} --</option>
                              {Object.keys(statuses).length > 0 &&
                                Object.entries(statuses).map(([key, value]) => (
                                  <option value={key} key={key}>
                                    {value}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-1">
                          <div className="form-group">
                            <button className="btn btn-primary" onClick={this.handleSearch}>
                              <i className="fa fa-search" />
                            </button>
                          </div>
                        </div>
                        {(this.state.input.qtext || this.state.input.rank) && (
                          <div className="col-md-1">
                            <div className="form-group">
                              <button
                                className="btn btn-outline-danger btn-block"
                                onClick={(e) => {
                                  let { input } = this.state;
                                  input.qtext = '';
                                  input.rank = '';
                                  this.setState({ input });
                                  this.handleSearch(e);
                                }}
                              >
                                <i className="fa fa-times" />
                              </button>
                            </div>
                          </div>
                        )}
                      </div>

                      {!this.state.is_loading && users.length === 0 && (
                        <div className="row pt-5">
                          <div className="col-6 m-auto">
                            <div className="alert border-danger text-danger text-center">
                              {i18n.t('no_meetingss_found')}
                            </div>
                          </div>
                        </div>
                      )}

                      {!this.state.is_loading && users.length > 0 && (
                        <div className="table-wrapper">
                          <DataTable
                            title=""
                            fixedHeader
                            columns={this.state.columns}
                            data={users}
                            customStyles={customStyles}
                            highlightOnHover
                            pagination
                            paginationServer
                            paginationTotalRows={this.state.totalRows}
                            paginationPerPage={15}
                            paginationDefaultPage={this.state.currentPage}
                            paginationRowsPerPageOptions={[15, 25, 50, 100]}
                            paginationComponentOptions={{
                              rowsPerPageText: i18n.t('meetings'),
                              rangeSeparatorText: i18n.t('out'),
                            }}
                            onChangePage={this.handlePageChange}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Modal size="lg" show={this.state.add_popup} onHide={() => this.setState({ add_popup: false })}>
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {i18n.t('add')} {i18n.t('meeting')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {screen_val === '1' && (
              <AddMeeting
                onReload={(opt) => {
                  this.setState({
                    screen_val: opt?.screen_val,
                    meetingID: opt?.meetingID,
                  });
                  this.triggerReload();
                }}
              />
            )}

            {screen_val === '2' && (
              <AttendeesLists
                id={meetingID}
                onFinished={() => {
                  this.setState({ add_popup: false });
                  this.triggerReload();
                }}
              />
            )}
          </Modal.Body>
        </Modal>

        <Modal size="lg" show={this.state.edit_popup} onHide={() => this.setState({ edit_popup: false })}>
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {i18n.t('edit')} {i18n.t('meeting')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <button
                onClick={() => {
                  this.setState({ edit_screen_val: '1' });
                }}
                className={`btn ${
                  edit_screen_val === '1' ? 'btn-primary' : 'btn-outline-dark'
                } btn-sm btn-block m-0 rounded-0`}
              >
                {i18n.t('meeting')}
              </button>
              <button
                onClick={() => {
                  this.setState({ edit_screen_val: '2' });
                }}
                className={`btn ${
                  edit_screen_val === '2' ? 'btn-primary' : 'btn-outline-dark'
                } btn-sm btn-block m-0 rounded-0`}
              >
                {i18n.t('attendees')}
              </button>
            </div>
            {edit_screen_val === '1' && (
              <EditMeeting
                groups={groups}
                id={meetingID}
                meeting={meeting}
                onReload={(opt) => {
                  this.setState({
                    edit_screen_val: opt?.screen_val,
                    meetingID: opt?.meetingID,
                  });
                  this.triggerReload();
                }}
              />
            )}
            {edit_screen_val === '2' && (
              <AttendeesEdit
                id={meetingID}
                is_edit={true}
                meeting={meeting}
                onFinished={() => {
                  this.setState({ attendees_popup: false });
                }}
              />
            )}
          </Modal.Body>
        </Modal>

        <Modal size="lg" show={this.state.attendees_popup} onHide={() => this.setState({ attendees_popup: false })}>
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">{i18n.t('attendees')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <MzadLoader animation="grow" size="md" loading={attendees_loading} style={{ position: 'relative' }} />
            {!attendees_loading && attendees.length === 0 && (
              <div className="alert alert-danger">{i18n.t('no_data_found')}</div>
            )}
            {!attendees_loading && attendees.length > 0 && (
              <table className="table table-responsive">
                <thead>
                  <tr>
                    <th>{i18n.t('id')}</th>
                    <th>{i18n.t('name')}</th>
                    <th>{i18n.t('approved')}</th>
                    <th>{i18n.t('notes')}</th>
                  </tr>
                </thead>
                <tbody>
                  {attendees.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>
                          <div>{lang === 'ar' ? item?.officer_details?.name_ar : item?.officer_details?.name}</div>
                          <div>
                            <small className="text-muted">{item.officer_details.rank}</small>
                          </div>
                        </td>
                        <td>
                          <span className={`badge bg-${item.approved ? 'success' : 'danger'}`}>
                            {item.approved ? i18n.t('yes') : i18n.t('no')}
                          </span>
                        </td>
                        <td>{item?.notes}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </Modal.Body>
        </Modal>
        <Modal size="lg" show={this.state.group_popup} onHide={() => this.setState({ group_popup: false })}>
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">{i18n.t('groups')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <MzadLoader animation="grow" size="md" style={{ position: 'relative' }} />
            {this.state.meetingGroups.length === 0 && (
              <div className="alert alert-danger">{i18n.t('no_data_found')}</div>
            )}
            {this.state.meetingGroups.length > 0 && (
              <table className="table table-responsive text-center">
                <thead>
                  <tr>
                    <th>{i18n.t('id')}</th>
                    <th>{i18n.t('group_name')}</th>
                    <th>{i18n.t('total_auctions')}</th>
                    <th>{i18n.t('total_bidders')}</th>
                    <th>{i18n.t('total_amount')}</th>
                    <th>{i18n.t('start_date')}</th>
                    <th>{i18n.t('end_date')}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.meetingGroups.map((item) => {
                    return (
                      <tr>
                        <td>{item.id}</td>
                        <td>
                          <p>{lang === 'ar' ? item?.group_name_ar : item?.group_name}</p>
                        </td>
                        <td>
                          <p>{item?.auctions.length}</p>
                        </td>
                        <td>
                          <p>{item?.winners_count?.total_bidders ?? '-'}</p>
                        </td>
                        <td>
                          <p>{item?.winner_bid_sum?.total_amount ?? '-'}</p>
                        </td>
                        <td>
                          <p>{item?.start_date}</p>
                        </td>
                        <td>
                          <p>{item?.end_date}</p>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}
